{
  "admin-hub-notifications.dropdown-menu-button.aria-label": [
    {
      "type": 0,
      "value": "More actions"
    }
  ],
  "admin-hub-notifications.unread-notifications.aria-label": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " unread notification"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " unread notifications"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "displayedCount"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.body-1": [
    {
      "type": 0,
      "value": "Different reports now live in dedicated spaces so you can quickly find what you need."
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.body-2": [
    {
      "type": 0,
      "value": "Assess your Data Center instances and get them ready for cloud migration."
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.body-3": [
    {
      "type": 0,
      "value": "Monitor and improve the health and performance of your Data Center instances."
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.body-4": [
    {
      "type": 0,
      "value": "Discover Data Center instances you own based on existing connections."
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.button-back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.button-next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-1": [
    {
      "type": 0,
      "value": "What's new in Portfolio insights"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-2": [
    {
      "type": 0,
      "value": "Cloud readiness"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-3": [
    {
      "type": 0,
      "value": "Instance health"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-4": [
    {
      "type": 0,
      "value": "Detected instances"
    }
  ],
  "admin-hub.adminhub-portfolio-insights-nav-spotlight.step-count": [
    {
      "type": 1,
      "value": "step"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "totalSteps"
    }
  ],
  "admin-hub.adminhub-rovo-chat-button-spotlight.body": [
    {
      "type": 0,
      "value": "Speed up troubleshooting and setup with Rovo skills. To get started, turn on "
    },
    {
      "type": 1,
      "value": "rovoChatInAdministration"
    },
    {
      "type": 0,
      "value": " in "
    },
    {
      "type": 1,
      "value": "rovoSettings"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "admin-hub.adminhub-rovo-chat-button-spotlight.button-open-rovo-chat": [
    {
      "type": 0,
      "value": "Open Rovo Chat"
    }
  ],
  "admin-hub.adminhub-rovo-chat-button-spotlight.heading": [
    {
      "type": 0,
      "value": "Meet your new admin assistant"
    }
  ],
  "admin-hub.adminhub-rovo-chat-button-spotlight.rovo-chat-in-administration": [
    {
      "type": 0,
      "value": "Rovo Chat in Administration"
    }
  ],
  "admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link": [
    {
      "type": 0,
      "value": "Rovo settings"
    }
  ],
  "admin-hub.adminhub-rovo-chat-toggle-spotlight.body": [
    {
      "type": 0,
      "value": "Turn on Rovo Chat to enable it in Atlassian Administration."
    }
  ],
  "admin-hub.adminhub-rovo-chat-toggle-spotlight.button-try-it": [
    {
      "type": 0,
      "value": "Turn on"
    }
  ],
  "admin-hub.adminhub-rovo-chat-toggle-spotlight.heading": [
    {
      "type": 0,
      "value": "Toggle on Rovo Chat"
    }
  ],
  "admin-hub.adminhub-theme-darkmode.button-back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "admin-hub.adminhub-theme-darkmode.button-done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "admin-hub.adminhub-theme-darkmode.button-next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "admin-hub.adminhub-theme-darkmode.spotlight-body-1": [
    {
      "type": 0,
      "value": "Reduce glare and boost focus with our sleek new dark theme."
    }
  ],
  "admin-hub.adminhub-theme-darkmode.spotlight-body-2": [
    {
      "type": 0,
      "value": "Go dark, stay light, or match your browser settings. Give it a try."
    }
  ],
  "admin-hub.adminhub-theme-darkmode.spotlight-heading-1": [
    {
      "type": 0,
      "value": "Experience dark mode"
    }
  ],
  "admin-hub.adminhub-theme-darkmode.spotlight-heading-2": [
    {
      "type": 0,
      "value": "Switch themes"
    }
  ],
  "admin-hub.adminhub-theme-darkmode.step-count-1": [
    {
      "type": 0,
      "value": "1 of 2"
    }
  ],
  "admin-hub.adminhub-theme-darkmode.step-count-2": [
    {
      "type": 0,
      "value": "2 of 2"
    }
  ],
  "adminhub.inbox.recommendations.placement.header": [
    {
      "type": 0,
      "value": "Recommendations"
    }
  ],
  "brie-automated-restore-failed.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t complete the automated restore test for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    },
    {
      "type": 0,
      "value": " run on "
    },
    {
      "type": 1,
      "value": "jobStartTimeTimestamp"
    },
    {
      "type": 0,
      "value": ". This may affect your ability to recover data if needed. Review restore test view more details."
    }
  ],
  "brie-automated-restore-failed.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Automated restore test did not complete"
    }
  ],
  "brie-backup-completed-admin-hub-in-app.admin-hub-notifications.action": [
    {
      "type": 0,
      "value": "Check Backup"
    }
  ],
  "brie-backup-completed-admin-hub-in-app.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "You can view details in the attached report or download the report for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "brie-backup-completed-admin-hub-in-app.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " backup "
    },
    {
      "type": 1,
      "value": "status"
    },
    {
      "type": 0,
      "value": " for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    }
  ],
  "brie-backup-failed.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "The backup for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    },
    {
      "type": 0,
      "value": " failed on "
    },
    {
      "type": 1,
      "value": "jobStartTimeTimestamp"
    },
    {
      "type": 0,
      "value": ". This means your latest data may not be protected. Review backup job to view more details."
    }
  ],
  "brie-backup-failed.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Backup failed"
    }
  ],
  "brie-backup-incomplete.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t complete the backup for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "jobStartTimeTimestamp"
    },
    {
      "type": 0,
      "value": ". This means your latest data may not be protected. Review backup job to view more details."
    }
  ],
  "brie-backup-incomplete.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Backup did not complete"
    }
  ],
  "brie-restore-completed-successfully.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "The restore job for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    },
    {
      "type": 0,
      "value": " finished successfully. Review restore job to view more details."
    }
  ],
  "brie-restore-completed-successfully.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Restore complete"
    }
  ],
  "brie-restore-failed.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "The restore for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    },
    {
      "type": 0,
      "value": " that started at "
    },
    {
      "type": 1,
      "value": "startTime"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "jobStartTimeTimestamp"
    },
    {
      "type": 0,
      "value": " has failed. Review restore job to view more details."
    }
  ],
  "brie-restore-failed.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Restore failed"
    }
  ],
  "brie-restore-incomplete.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t complete the restore for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    },
    {
      "type": 0,
      "value": " started at "
    },
    {
      "type": 1,
      "value": "startTime"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "jobStartTimeTimestamp"
    },
    {
      "type": 0,
      "value": ". Review restore job to view more details."
    }
  ],
  "brie-restore-incomplete.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Restore did not complete"
    }
  ],
  "brie-scheduler-halted-access-issue.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t run the scheduled backup for "
    },
    {
      "type": 1,
      "value": "cloudUrl"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "type": 1,
      "value": "jobStartTimeTimestamp"
    },
    {
      "type": 0,
      "value": " due to a user access issue. This means your latest data may not be protected."
    }
  ],
  "brie-scheduler-halted-access-issue.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Scheduled backup could not run"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " is over the user limit"
    }
  ],
  "commerce.commerce-soft-limit-breach-ccp.body-default.no-translate": [
    {
      "type": 0,
      "value": "We recommend removing users as soon as possible if you don't want to automatically upgrade user tiers"
    }
  ],
  "encryption.policy-page.spotlight.apps": [
    {
      "type": 0,
      "value": "Your CMK encrypted apps will appear here."
    }
  ],
  "encryption.policy-page.spotlight.back": [
    {
      "type": 0,
      "value": "Back"
    }
  ],
  "encryption.policy-page.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "encryption.policy-page.spotlight.done": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "encryption.policy-page.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "encryption.policy-page.spotlight.tenantIdVpce": [
    {
      "type": 0,
      "value": "Update your AWS KMS key policy with Encryption Tenant Identifier-tag pair and VPC endpoint(s) to enhance security."
    }
  ],
  "growth-groot.pending-request-access-summary.admin-hub-notification.body": [
    {
      "type": 0,
      "value": "Approve or deny your users' requests for app access."
    }
  ],
  "growth-groot.pending-request-access-summary.admin-hub-notification.heading": [
    {
      "type": 1,
      "value": "totalRequests"
    },
    {
      "type": 0,
      "value": " access requests are waiting for review"
    }
  ],
  "placement.admin-hub-notifications.beta": [
    {
      "type": 0,
      "value": "BETA"
    }
  ],
  "placement.admin-hub-notifications.button.markAsRead": [
    {
      "type": 0,
      "value": "Mark all as read"
    }
  ],
  "placement.admin-hub-notifications.give-feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "placement.admin-hub-notifications.learn-more.beta": [
    {
      "type": 0,
      "value": "About this feature"
    }
  ],
  "placement.admin-hub-notifications.main-heading": [
    {
      "type": 0,
      "value": "Notifications"
    }
  ],
  "placement.admin-hub-notifications.mark-as-read-tooltip": [
    {
      "type": 0,
      "value": "Mark as read"
    }
  ],
  "placement.admin-hub-notifications.mark-as-unread-tooltip": [
    {
      "type": 0,
      "value": "Mark as unread"
    }
  ],
  "post-office.access-invalid-payment.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.access-invalid-payment.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.access-missing-payment.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add your payment details by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.access-missing-payment.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.admin-hub-expiring-customer-account-scim-tokens.notification.actionLink": [
    {
      "type": 0,
      "value": "Regenerate key"
    }
  ],
  "post-office.admin-hub-expiring-customer-account-scim-tokens.notification.body": [
    {
      "type": 0,
      "value": "Regenerate key for "
    },
    {
      "type": 1,
      "value": "directoryName"
    },
    {
      "type": 0,
      "value": " to continue customer provisioning."
    }
  ],
  "post-office.admin-hub-expiring-customer-account-scim-tokens.notification.header": [
    {
      "type": 0,
      "value": "Your SCIM API key will expire on "
    },
    {
      "type": 1,
      "value": "expirationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.admin-hub-expiring-scim-tokens.notification.actionLink": [
    {
      "type": 0,
      "value": "Regenerate key"
    }
  ],
  "post-office.admin-hub-expiring-scim-tokens.notification.body": [
    {
      "type": 0,
      "value": "Regenerate key for "
    },
    {
      "type": 1,
      "value": "directoryName"
    },
    {
      "type": 0,
      "value": " to continue user provisioning."
    }
  ],
  "post-office.admin-hub-expiring-scim-tokens.notification.header": [
    {
      "type": 0,
      "value": "Your SCIM API key will expire on "
    },
    {
      "type": 1,
      "value": "expirationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.body.non-final": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " requested org admin permissions for "
    },
    {
      "type": 1,
      "value": "orgName"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.heading.non-final": [
    {
      "type": 0,
      "value": "Org Admin Request"
    }
  ],
  "post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We've found "
    },
    {
      "children": [
        {
          "offset": 0,
          "options": {
            "one": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " Atlassian app"
                }
              ]
            },
            "other": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " Atlassian apps"
                }
              ]
            }
          },
          "pluralType": "cardinal",
          "type": 6,
          "value": "products"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " that might belong to your portfolio. Review and connect them to get more insights. "
    }
  ],
  "post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Detected "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Atlassian app"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " Atlassian apps"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "products"
    }
  ],
  "post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.notification.buttonText": [
    {
      "type": 0,
      "value": "Review detected apps"
    }
  ],
  "post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We've found "
    },
    {
      "children": [
        {
          "offset": 0,
          "options": {
            "one": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " product"
                }
              ]
            },
            "other": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " products"
                }
              ]
            }
          },
          "pluralType": "cardinal",
          "type": 6,
          "value": "products"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " that might belong to your portfolio. Review and connect them to get more insights. "
    }
  ],
  "post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Detected "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " product"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " products"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "products"
    }
  ],
  "post-office.admin-hub-portfolio-analyzer-new-product-discovered.notification.buttonText": [
    {
      "type": 0,
      "value": "Review detected products"
    }
  ],
  "post-office.adminhub-common.email-header.atlassian-logo-alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We're consolidating groups and teams visibility to support future improvements and features. Assign teams to a site to avoid losing team data."
    }
  ],
  "post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Teams must be assigned to sites"
    }
  ],
  "post-office.adminhub-scope-alignment-reminder.notification.buttonText": [
    {
      "type": 0,
      "value": "Assign teams"
    }
  ],
  "post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.action": [
    {
      "type": 0,
      "value": "Review new bill"
    }
  ],
  "post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "You can now be billed for this app based on the number of Jira Service Management agents, instead of Jira users. If you don't switch to the new way of billing, we'll transition you automatically soon."
    }
  ],
  "post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Move to a new way of billing for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for Jira Service Management"
    }
  ],
  "post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.action": [
    {
      "type": 0,
      "value": "View subscription"
    }
  ],
  "post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "The way you're billed for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for Jira Service Management has been updated, which means you're now billed based on the number of JSM agents who have access to the app. Organization admins can view and manage user access in Atlassian Administration."
    }
  ],
  "post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Enjoy more control over billing for "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " for JSM"
    }
  ],
  "post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "You can start your download by clicking here"
    }
  ],
  "post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "JSON file for invoice ["
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": "] is ready"
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Get a free trial of "
    },
    {
      "type": 1,
      "value": "entitlementOne"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "entitlementTwo"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": " with your "
    },
    {
      "type": 1,
      "value": "purchasedEntitlement"
    },
    {
      "type": 0,
      "value": " purchase."
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "entitlementOne"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "entitlementTwo"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": " free"
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Get a free trial of "
    },
    {
      "type": 1,
      "value": "entitlementOne"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "entitlementTwo"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": " with your "
    },
    {
      "type": 1,
      "value": "purchasedEntitlement"
    },
    {
      "type": 0,
      "value": " purchase."
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Try "
    },
    {
      "type": 1,
      "value": "entitlementOne"
    },
    {
      "type": 0,
      "value": " & "
    },
    {
      "type": 1,
      "value": "entitlementTwo"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": " free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Tired of hunting for the right doc? Build a single source of truth for your team’s info with Confluence "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": ". Free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Try Confluence"
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "With Jira, your team can move fast, stay aligned, and build better - together. Try the "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": " plan free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Try Jira"
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": ". Free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Try Jira Product Discovery"
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Bring developers, IT, and ops on the same tool and make work visible across teams with the "
    },
    {
      "type": 1,
      "value": "entitlementOneOfferingName"
    },
    {
      "type": 0,
      "value": " plan. Free for "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " day"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " days"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "trialLength"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Try Jira Service Management"
    }
  ],
  "post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We’ll need a payment method before "
    },
    {
      "type": 1,
      "value": "lastDate"
    },
    {
      "type": 0,
      "value": " to start the migration, otherwise migration will be cancelled automatically"
    }
  ],
  "post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Migrating Opsgenie to "
    },
    {
      "type": 1,
      "value": "targetProductName"
    },
    {
      "type": 0,
      "value": ", bill approval pending"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ll migrate from Opsgenie to your Atlassian cloud app on "
    },
    {
      "type": 1,
      "value": "migrationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the potential increase in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ll migrate from Opsgenie to your Atlassian cloud product on "
    },
    {
      "type": 1,
      "value": "migrationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the potential increase in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We're providing a "
    },
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "discountPercentage"
    },
    {
      "type": 0,
      "value": " discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who’ll migrate from Opsgenie to your Atlassian cloud app on "
    },
    {
      "type": 1,
      "value": "migrationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.header.heading": [
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "discountPercentage"
    },
    {
      "type": 0,
      "value": " discount applied on your Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We're providing a "
    },
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "discountPercentage"
    },
    {
      "type": 0,
      "value": " discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who’ll migrate from Opsgenie to your Atlassian cloud product on "
    },
    {
      "type": 1,
      "value": "migrationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.header.heading": [
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "discountPercentage"
    },
    {
      "type": 0,
      "value": " discount applied on your Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ll migrate from Opsgenie to your Atlassian cloud app on "
    },
    {
      "type": 1,
      "value": "migrationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the changes in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.manage-users": [
    {
      "type": 0,
      "value": "Manage users"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.review-subscription": [
    {
      "type": 0,
      "value": "Review subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.secondary-action": [
    {
      "type": 0,
      "value": "Download Report"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ll migrate from Opsgenie to your Atlassian cloud product on "
    },
    {
      "type": 1,
      "value": "migrationDate"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the changes in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.manage-users": [
    {
      "type": 0,
      "value": "Manage users"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.review-subscription": [
    {
      "type": 0,
      "value": "Review subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ve migrated from Opsgenie to your Atlassian cloud app."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the potential increase in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ve migrated from Opsgenie to your Atlassian cloud product."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the potential increase in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We’re providing a "
    },
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "discountPercentage"
    },
    {
      "type": 0,
      "value": " discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the bill estimate of the discounted Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We’re providing a "
    },
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "discountPercentage"
    },
    {
      "type": 0,
      "value": " discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the bill estimate of the discounted Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ve migrated from Opsgenie to your Atlassian cloud app."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the changes in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.manage-users": [
    {
      "type": 0,
      "value": "Manage users"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.review-subscription": [
    {
      "type": 0,
      "value": "Review subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "Ensure the bill estimate of your subscription is correct based on the number of users who’ve migrated from Opsgenie to your Atlassian cloud product."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the changes in your bill estimate"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.manage-users": [
    {
      "type": 0,
      "value": "Manage users"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.review-subscription": [
    {
      "type": 0,
      "value": "Review subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We've activated a new Atlassian Guard subscription with a "
    },
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "fullDiscountPercentage"
    },
    {
      "type": 0,
      "value": " discount for one year. Review the subscription plan."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "A new Atlassian Guard subscription has been activated"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We've activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who’ll use Atlassian Guard."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Configure your Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We've activated a new Atlassian Guard subscription with "
    },
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "fullDiscountPercentage"
    },
    {
      "type": 0,
      "value": " discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the bill estimate of your newly activated Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We've activated a new Atlassian Guard subscription with "
    },
    {
      "style": {
        "parsedOptions": {
          "maximumFractionDigits": 1,
          "style": "percent"
        },
        "tokens": [
          {
            "options": [
            ],
            "stem": "percent"
          },
          {
            "options": [
            ],
            "stem": ".#"
          }
        ],
        "type": 0
      },
      "type": 2,
      "value": "fullDiscountPercentage"
    },
    {
      "type": 0,
      "value": " discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Review the bill estimate of your newly activated Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We've activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who’ll use Atlassian Guard."
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.header.heading": [
    {
      "type": 0,
      "value": "Configure your Atlassian Guard subscription"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.body": [
    {
      "type": 1,
      "value": "bodyContent"
    }
  ],
  "post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.header.heading": [
    {
      "type": 1,
      "value": "titleContent"
    }
  ],
  "post-office.commerce-payment-failure-hams-atlassian-access-paid.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details."
    }
  ],
  "post-office.commerce-payment-failure-hams-atlassian-access-paid.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add payment details as soon as possible."
    }
  ],
  "post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.commerce-payment-failure-hams-multi-product-paid.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for subscriptions for this site ("
    },
    {
      "type": 1,
      "value": "siteUrl"
    },
    {
      "type": 0,
      "value": ") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."
    }
  ],
  "post-office.commerce-payment-failure-hams-multi-product-paid.heading": [
    {
      "type": 0,
      "value": "Payment failed for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " +"
    },
    {
      "type": 1,
      "value": "remainingProducts"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "post-office.commerce-payment-failure-hams-multi-product-trial.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for subscriptions for this site ("
    },
    {
      "type": 1,
      "value": "siteUrl"
    },
    {
      "type": 0,
      "value": "). To avoid your subscription being deactivated, add payment details as soon as possible."
    }
  ],
  "post-office.commerce-payment-failure-hams-multi-product-trial.heading": [
    {
      "type": 0,
      "value": "Payment failed for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " +"
    },
    {
      "type": 1,
      "value": "remainingProducts"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for your subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."
    }
  ],
  "post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."
    }
  ],
  "post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.commerce-payment-failure-trials-multi-product-invalid-payment.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for subscriptions on your invoice ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": ") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."
    }
  ],
  "post-office.commerce-payment-failure-trials-multi-product-invalid-payment.heading": [
    {
      "type": 0,
      "value": "Payment failed for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " +"
    },
    {
      "type": 1,
      "value": "remainingProducts"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "post-office.commerce-payment-failure-trials-multi-product-missing-payment.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for your subscriptions on your invoice ("
    },
    {
      "type": 1,
      "value": "invoiceNumber"
    },
    {
      "type": 0,
      "value": "). To avoid your subscriptions being deactivated, add payment details as soon as possible."
    }
  ],
  "post-office.commerce-payment-failure-trials-multi-product-missing-payment.heading": [
    {
      "type": 0,
      "value": "Payment failed for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " +"
    },
    {
      "type": 1,
      "value": "remainingProducts"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "post-office.commerce-payment-failure-trials-single-product-invalid-payment.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."
    }
  ],
  "post-office.commerce-payment-failure-trials-single-product-invalid-payment.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.commerce-payment-failure-trials-single-product-missing-payment.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details."
    }
  ],
  "post-office.commerce-payment-failure-trials-single-product-missing-payment.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.body.no-translate": [
    {
      "options": {
        "other": {
          "value": [
            {
              "type": 0,
              "value": "Hi, I’d like to request an upgrade and need payment details added to this subscription."
            }
          ]
        },
        "true": {
          "value": [
            {
              "type": 1,
              "value": "customMessage"
            }
          ]
        }
      },
      "type": 5,
      "value": "hasCustomMessage"
    }
  ],
  "post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Request to add payment from "
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.body.no-translate": [
    {
      "type": 0,
      "value": "Great news! Your request has been approved. Billing admin has added payment details to your subscription."
    }
  ],
  "post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Payment details added by billing admin"
    }
  ],
  "post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.body.no-translate": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "children": [
        {
          "type": 1,
          "value": "email"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ") requested billing admin permission."
    }
  ],
  "post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Billing admin access requested"
    }
  ],
  "post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "Your billing admin request was approved."
    }
  ],
  "post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "You're now a billing admin"
    }
  ],
  "post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "Your billing admin request was declined. If needed, you can submit another request."
    }
  ],
  "post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Your request to be a billing admin was declined"
    }
  ],
  "post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for some of your subscriptions. To avoid your subscriptions being deactivated, add payment details as soon as possible."
    }
  ],
  "post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.heading": [
    {
      "type": 0,
      "value": "Your trial expired for "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " +"
    },
    {
      "type": 1,
      "value": "remainingProducts"
    },
    {
      "type": 0,
      "value": " more"
    }
  ],
  "post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."
    }
  ],
  "post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.heading": [
    {
      "type": 0,
      "value": "Your "
    },
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " trial expired"
    }
  ],
  "post-office.commerce-quote-json-download-ppc.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "You can start your download by clicking here"
    }
  ],
  "post-office.commerce-quote-json-download-ppc.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "JSON file for quote ["
    },
    {
      "type": 1,
      "value": "quoteNumber"
    },
    {
      "type": 0,
      "value": "] is ready"
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "Your org has used "
    },
    {
      "type": 1,
      "value": "usageMileStone"
    },
    {
      "type": 0,
      "value": "% of its "
    },
    {
      "type": 1,
      "value": "chargeElement"
    },
    {
      "type": 0,
      "value": " allowance. Monitor your org’s usage in Atlassian Administration."
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "chargeElement"
    },
    {
      "type": 0,
      "value": " allowance reached"
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "Your org has used "
    },
    {
      "type": 1,
      "value": "usageMileStone"
    },
    {
      "type": 0,
      "value": "% of its "
    },
    {
      "type": 1,
      "value": "chargeElement"
    },
    {
      "type": 0,
      "value": " allowance. Monitor your org’s usage in Atlassian Administration."
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "usageMileStone"
    },
    {
      "type": 0,
      "value": "% of "
    },
    {
      "type": 1,
      "value": "chargeElement"
    },
    {
      "type": 0,
      "value": " allowance used"
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-view-usage.admin-hub-notifications.action": [
    {
      "type": 0,
      "value": "View usage"
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.action": [
    {
      "type": 0,
      "value": "Request upgrade"
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "Rovo Dev will be disabled for users who reach their limit. Allow more credits by requesting an upgrade to Rovo Dev Standard."
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Upgrade Rovo Dev users to avoid interruption"
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "At least one user has reached "
    },
    {
      "type": 1,
      "value": "usageMileStone"
    },
    {
      "type": 0,
      "value": "% of their Rovo Dev credit limit. If extra usage is enabled, extra charges will apply to use over the limit. Otherwise, Rovo Dev will be disabled for those users."
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "usageMileStone"
    },
    {
      "type": 0,
      "value": "% of Rovo Dev credits used"
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "If an extra usage limit has been set, Rovo Dev usage will be disabled for those users. Otherwise, charges will apply for extra usage."
    }
  ],
  "post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Users have reached their Rovo Dev credit limit"
    }
  ],
  "post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "A "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been added to your billing account ("
    },
    {
      "type": 1,
      "value": "transactionAccountNumber"
    },
    {
      "type": 0,
      "value": "). You can move it to a different billing account until your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "New subscription added to your account"
    }
  ],
  "post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "A "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been added to your billing account ("
    },
    {
      "type": 1,
      "value": "transactionAccountNumber"
    },
    {
      "type": 0,
      "value": "). You can move it to a different billing account until your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "New subscription added to your account"
    }
  ],
  "post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "A "
    },
    {
      "type": 1,
      "value": "productName"
    },
    {
      "type": 0,
      "value": " subscription has been added to your billing account ("
    },
    {
      "type": 1,
      "value": "transactionAccountNumber"
    },
    {
      "type": 0,
      "value": "). You can move it to a different billing account until your trial ends on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "trialEndDate"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "New subscription added to your account"
    }
  ],
  "post-office.common.email.body.sent-by-atlassian-cloud.footer.org-id": [
    {
      "type": 0,
      "value": " (ID: "
    },
    {
      "type": 1,
      "value": "orgId"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "post-office.common.email.body.sent-by-atlassian-cloud.footer.text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Administration. You are receiving this email because you are an admin for "
    },
    {
      "type": 1,
      "value": "orgName"
    }
  ],
  "post-office.et-domain-verification-missing-token.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "We're unable to verify that you own "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "domain"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " due to missing tokens. Verify this domain to keep your managed accounts."
    }
  ],
  "post-office.et-domain-verification-missing-token.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Domain will be unverified in "
    },
    {
      "type": 1,
      "value": "remainingDays"
    },
    {
      "type": 0,
      "value": " days"
    }
  ],
  "post-office.et-domain-verification-token-revoked.admin-hub.notification.body": [
    {
      "children": [
        {
          "type": 1,
          "value": "domain"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " is no longer verified. Accounts with this domain are now unmanaged. Verify the domain again to claim these accounts."
    }
  ],
  "post-office.et-domain-verification-token-revoked.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Domain has been unverified"
    }
  ],
  "post-office.generic-invalid-payment.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for your subscription because of an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.generic-invalid-payment.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.generic-missing-payment.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We don’t have payment details for your subscription. To avoid your subscription being deactivated, add payment details by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.generic-missing-payment.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.multi-generic-invalid.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for subscriptions on this site "
    },
    {
      "type": 1,
      "value": "siteUrl"
    },
    {
      "type": 0,
      "value": " due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.multi-generic-invalid.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Payment failed"
    }
  ],
  "post-office.multi-generic-missing.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for subscriptions on this site "
    },
    {
      "type": 1,
      "value": "siteUrl"
    },
    {
      "type": 0,
      "value": ". To avoid your subscription being deactivated, add payment details by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.multi-generic-missing.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "Payment failed"
    }
  ],
  "post-office.one-admin-left-notification.admin-hub.notification.body": [
    {
      "type": 0,
      "value": "You're the only organization admin for this organization. Add another admin to avoid being locked out if you lose access."
    }
  ],
  "post-office.one-admin-left-notification.admin-hub.notification.header": [
    {
      "type": 0,
      "value": "Only one organization admin"
    }
  ],
  "post-office.one-admin-left-notification.admin-hub.notification.how-to-add-admin-link": [
    {
      "type": 0,
      "value": "How to add an admin"
    }
  ],
  "post-office.one-admin-left-notification.notification.add-another-admin-link": [
    {
      "type": 0,
      "value": "Add another organization admin"
    }
  ],
  "post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "You can view the PVR registration by clicking here"
    }
  ],
  "post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "PVR registration "
    },
    {
      "type": 1,
      "value": "pvrNumber"
    },
    {
      "type": 0,
      "value": " submitted by "
    },
    {
      "type": 1,
      "value": "submittedBy"
    }
  ],
  "post-office.pure-dynamic-template.admin-hub.notification.body.no-translate": [
    {
      "type": 1,
      "value": "bodyText"
    }
  ],
  "post-office.pure-dynamic-template.admin-hub.notification.header.heading.no-translate": [
    {
      "type": 1,
      "value": "headingText"
    }
  ],
  "post-office.single-generic-invalid.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t process payment for your subscription due to a problem with your payment details. To avoid your subscription being deactivated, update your payment details by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.single-generic-invalid.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.single-generic-missing.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We don’t have a payment method for your subscription. To avoid your subscription being deactivated, add a payment method by "
    },
    {
      "type": 1,
      "value": "paymentDue"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "post-office.single-generic-missing.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "product"
    },
    {
      "type": 0,
      "value": " payment failed"
    }
  ],
  "post-office.three-ds-payment-failure.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "We couldn’t process your payment since we need your help to complete 3-D Secure (3DS) authentication."
    }
  ],
  "post-office.three-ds-payment-failure.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "3DS payment failure"
    }
  ],
  "post-office.townsquare-goals-request-trial.admin-hub-notifications.body": [
    {
      "type": 0,
      "value": "Hi, I’d like to try goals in the early access program. I think it can help the team save time and work better together. It’s free to try if we’re eligible."
    }
  ],
  "post-office.townsquare-goals-request-trial.admin-hub-notifications.heading": [
    {
      "type": 1,
      "value": "requesterName"
    },
    {
      "type": 0,
      "value": " sent an approval request."
    }
  ],
  "toggleLabel": [
    {
      "type": 0,
      "value": "Only show unread"
    }
  ],
  "townsquare-ai-features-release.admin-hub-notifications.actionLink": [
    {
      "type": 0,
      "value": "Manage AI settings"
    }
  ],
  "townsquare-ai-features-release.admin-hub-notifications.body": [
    {
      "children": [
        {
          "type": 0,
          "value": "Rovo-powered updates help your teams write clearer status update with less effort. Now, Rovo can draft project updates and shorten written drafts in both apps."
        }
      ],
      "type": 8,
      "value": "AdminLogoContainer"
    }
  ],
  "townsquare-ai-features-release.admin-hub-notifications.heading": [
    {
      "type": 0,
      "value": "New AI features are available in Goals and Projects"
    }
  ],
  "townsquare-ai-features-release.admin-hub-notifications.secondaryButtonLink": [
    {
      "type": 0,
      "value": "How it works"
    }
  ]
}